import todaySVG from './today.svg';

const calendarWidth = '308px';

const styles = (theme) => ({
  dateInput: {
    '&:placeholder-shown': {
      paddingLeft: 40,
      backgroundImage: `url('${todaySVG}')`,
      backgroundRepeat: 'no-repeat',
      backgroundPosition: `${theme.spacing.unit}px center`,
    },
  },
  datePicker: {
    '& > input': {
      zIndex: -1,
      position: 'absolute',
    },
    '&.flatpickr-calendar': {
      fontFamily: 'Calibre',
      top: 0,
      position: 'absolute',
      zIndex: 1000,
      '&.flatpickr-calendar': {
        [theme.breakpoints.down('xs')]: {
          width: calendarWidth,
        },
        '& .flatpickr-months .flatpickr-month': {
          height: 55,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          fontSize: '1.0625rem',
          '& .flatpickr-current-month': {
            paddingTop: 0,
          },
        },
        // Next/previous month buttons.
        '& .flatpickr-prev-month, & .flatpickr-next-month': {
          '&:hover svg': {
            background: theme.palette.primary.dark,
            fill: theme.palette.text.white,
          },
          '& svg': {
            border: `1px solid ${theme.palette.primary.dark}`,
            borderRadius: '50%',
            width: 30,
            height: 30,
            padding: 6,
          },
        },
        // Month dropdown
        '& .flatpickr-monthDropdown-months': {
          color: theme.palette.text.dark,
          fontSize: '1.25rem',
        },
        // Year input
        '& .numInput': {
          color: theme.palette.text.dark,
          fontSize: '1.25rem',
          '& + .arrowUp, & + * + .arrowDown': {
            display: 'none',
          },
        },
        // Days
        '& .flatpickr-day': {
          color: theme.palette.text.dark,
          fontSize: '1.0625rem',
          [theme.breakpoints.down('xs')]: {
            width: calendarWidth,
          },
          '&.nextMonthDay,&.prevMonthDay,&.flatpickr-disabled': {
            color: theme.palette.text.lightGrey,
          },
          '&.today': {
            borderColor: theme.palette.primary.dark,
          },
          '&.selected': {
            background: theme.palette.primary.dark,
            color: theme.palette.primary.contrastText,
          },
          '&:hover, &:focus': {
            background: theme.palette.primary.dark,
            color: theme.palette.primary.contrastText,
          },
          '& .dayContainer': {
            [theme.breakpoints.down('xs')]: {
              width: calendarWidth,
              minWidth: calendarWidth,
            },
          },
        },
      },
    },
  },
});

export default styles;
